import React from 'react';
import { useDispatch } from 'react-redux';
import { CreateChancel } from 'components';
import { FindLoad, useModal } from 'utils';
import { appointmentActions } from 'store';
import { updateNoteEnums } from './constnats';

const ACTION_TYPE = 'REQUEST_APPT_NOTE';

export const MarkResolved = ({ note, apptId, single }) => {
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const { close } = useModal();
    const handleMark = () => {
        dispatch(appointmentActions.requestApptNote(apptId, { type: updateNoteEnums?.RESOLVE_UPDATE, noteId: note?.id }, single));
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">Mark Note Request as Resolved?</p>
            <p style={{ marginBottom: 32 }} className="modal-header-sub">
                This will notify the requester that you've addressed the requested changes.
            </p>
            <CreateChancel
                onCreate={handleMark}
                loader={!!loader.length}
                create={'Mark as Resolved'}
                chancel={'Cancel'}
                onClose={close}
                buttonWidth="100%"
            />
        </div>
    );
};
